import PropTypes from "prop-types";
import { useEffect } from "react";
import { FormattedMessage } from "react-intl";
import { useLocation } from "react-router-dom";
import { parse } from "qs";
import AlertMessage from "app/components/ui/AlertMessage/AlertMessage";
import ProductNameWithCategory from "app/pages/.shared/ProductNameWithCategory/ProductNameWithCategory";
import { useAnalytics } from "app/utils/analytics/useAnalytics";
import "./SdpPartialSuccessAlertMessage.scss";

const SdpPartialSuccessAlertMessage = ({ accommodation }) => {
	const { track } = useAnalytics();
	const { search } = useLocation();
	const { departureDate, endDate } = parse(search, { ignoreQueryPrefix: true });

	useEffect(() => {
		track("hotel_not_available_displayed", {
			hotelName: accommodation?.name,
			departureDate,
			endDate,
		});
	}, []);

	return (
		<div className="sdp-partial-success-alert-message">
			<AlertMessage
				message={
					<FormattedMessage
						id="sdp.listing.hotel.not.available.message"
						values={{
							hotel: (
								<b>
									<ProductNameWithCategory
										category={accommodation?.category}
										name={accommodation?.name}
									/>
								</b>
							),
						}}
					/>
				}
			/>
		</div>
	);
};

SdpPartialSuccessAlertMessage.propTypes = {
	accommodation: PropTypes.shape({
		category: PropTypes.string,
		name: PropTypes.string,
	}),
};

export default SdpPartialSuccessAlertMessage;
